import React, {Component} from "react";

class BrandsList extends Component {
    constructor(props) {
        super(props);
        this.createEntries = this.createEntries.bind(this);
    }

    createEntries(item) {
        return (
            <article key={item.id} className="brand-card col-12 col-md-4">
                <h3 className="brand-card__title">{item.title}</h3>
                <a href="#"
                   onClick={e => {
                       e.preventDefault();
                       this.props.onItemClick(item.id);
                   }}
                   className="brand-card__image-container d-flex flex-column align-items-center justify-content-center">
                    <img src={item.background_image} alt="" className="brand-card__background"/>
                    <img src={item.foreground_image} alt="" className="brand-card__bottle"/>
                </a>
                <div className="text-center">
                    <a className="button button--choose-brand" href="#" onClick={() => this.props.onItemClick(item.id)}>
                        VEZI DRINKS
                    </a>
                </div>
            </article>
        );
    }

    render() {
        return (
            <div className="choose-brand__cards d-flex flex-wrap justify-content-center align-items-center">
                {this.props.items.map(this.createEntries)}
            </div>
        );
    }
}

export default BrandsList;
